import { render } from "./Medico_Cita.vue?vue&type=template&id=2e7c3e5e"
import script from "./Medico_Cita.vue?vue&type=script&lang=js"
export * from "./Medico_Cita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__